import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["link"]
  static values = {
    activeClass: { type: String, default: "active" },
    frame: String
  }

  connect() {
    this.ensureActive()
  }

  activate(event) {
    const link = event.currentTarget
    this.setActive(link)
    if (!this.hasFrameValue || !link.href) {
      return
    }

    event.preventDefault()
    Turbo.visit(link.href, { frame: this.frameValue })
  }

  ensureActive() {
    if (this.linkTargets.some((link) => link.classList.contains(this.activeClassValue))) {
      return
    }

    if (this.linkTargets.length > 0) {
      this.setActive(this.linkTargets[0])
    }
  }

  setActive(activeLink) {
    this.linkTargets.forEach((link) => {
      const isActive = link === activeLink
      link.classList.toggle(this.activeClassValue, isActive)
      if (isActive) {
        link.setAttribute("aria-current", "page")
      } else {
        link.removeAttribute("aria-current")
      }
    })
  }
}
